import Vue from "vue";
import Component from "vue-class-component";
import {
  DetailTotal,
  DetailModel,
  MedicalSpecification
} from "@/components/medicalTransmissionEdit/types";
import { SelectItem, PulldownItem, SelectItemString } from "@/types";
import { Prop, Ref } from "vue-property-decorator";
import DiseaseSettingDialog from "@/components/medicalTransmissionEdit/DiseaseSettingDialog.vue";

@Component
export default class MedicalTransmissionBase extends Vue {
  @Ref("diseaseDialog") readonly diseaseDialog!: DiseaseSettingDialog; //疾病ダイアログ

  @Prop() tab!: MedicalSpecification;

  @Prop() ins_type_items!: PulldownItem[]; //保険種類アイテムリスト
  @Prop() ins_multi_items!: PulldownItem[]; //保険併用アイテムリスト
  @Prop() ins_div_items!: PulldownItem[]; //保険区分アイテムリスト
  @Prop() public_option_divs!: SelectItemString[]; //任意給付区分
  @Prop() sex_items!: SelectItem[]; //性別選択アイテムリスト
  @Prop() receipt_special_codes!: SelectItemString[]; //レセプト特記コード
  @Prop() readmission_category_codes!: SelectItemString[]; //再入院等区分コード
  @Prop() partial_payment_category_codes!: SelectItemString[]; //一部負担金区分コード
  @Prop() occupational_reason_codes!: SelectItemString[]; //職務上の事由コード
  @Prop() payer_type_codes!: SelectItemString[]; //負担者種別コード
  @Prop() confirmation_category_codes!: SelectItemString[]; //確認区分コード
  @Prop() prefecturess!: PulldownItem[]; //都道府県コード
  @Prop() prefectures_strings!: SelectItemString[]; //都道府県コード（string版）
  @Prop() list_marks_codes!: SelectItemString[]; //点数表コード
  @Prop() patient_information_codes!: SelectItemString[]; //利用者情報コード
  @Prop() location_codes!: SelectItemString[]; //場所コード
  @Prop() end_visit_status_codes!: SelectItemString[]; //訪問終了の状況コード
  @Prop() beppyou_items!: SelectItem[]; //別表選択アイテムリスト
  @Prop() specialty_training_codes!: SelectItemString[]; //専門の研修コード

  @Prop() burden_category_codes!: SelectItemString[]; //負担区分コード（画面用）
  @Prop() occupation_codes!: SelectItemString[]; //職種等コード
  @Prop() visit_frequency_codes!: SelectItemString[]; //訪問看護回数コード
  @Prop() instruction_classification_codes!: SelectItemString[]; //指示区分コード

  @Prop() medical_examination_classification_codes!: PulldownItem[]; //受診等区分コード

  @Prop() reduction_unit_items!: SelectItem[]; //減額単位アイテムリスト
  @Prop() exemption_category_codes!: SelectItem[]; //減免区分コード
  @Prop() customer_amount_codes!: SelectItemString[]; //窓口負担額区分コード

  selectItemTab = 0; //選択中のタブ

  openDialog() {
    this.diseaseDialog.open(this.tab.beppyou_code);
  }

  private calcDetail(details: DetailModel[]): DetailTotal {
    const res: DetailTotal = {
      insuarnce: 0,
      public_money1: 0,
      public_money2: 0,
      public_money3: 0,
      public_money4: 0
    };
    details.forEach(item => {
      item.burden_divs.forEach(div => {
        switch (div) {
          // 保険
          case "1":
            res.insuarnce += item.price;
            break;
          // 公費1
          case "2":
            res.public_money1 += item.price;
            break;
          // 公費2
          case "3":
            res.public_money2 += item.price;
            break;
          // 公費3
          case "4":
            res.public_money3 += item.price;
            break;
          // 公費4
          case "5":
            res.public_money4 += item.price;
            break;
        }
      });
    });
    return res;
  }

  /**
   * 療養費変更時 保険、公費1,2,3,4合計値計算処理
   */
  changeDetail() {
    const basicTotal = this.calcDetail(this.tab.basic_details);
    const managementTotal = this.calcDetail(this.tab.management_details);
    const mtsaTotal = this.calcDetail(this.tab.mtsa_details);
    const mindTotal = this.calcDetail(this.tab.mind_details);
    this.tab.total_invoice1 =
      basicTotal.insuarnce +
      managementTotal.insuarnce +
      mtsaTotal.insuarnce +
      mindTotal.insuarnce;
    this.tab.total_invoice2 =
      basicTotal.public_money1 +
      managementTotal.public_money1 +
      mtsaTotal.public_money1 +
      mindTotal.public_money1;
    this.tab.total_invoice3 =
      basicTotal.public_money2 +
      managementTotal.public_money2 +
      mtsaTotal.public_money2 +
      mindTotal.public_money2;
    this.tab.total_invoice4 =
      basicTotal.public_money3 +
      managementTotal.public_money3 +
      mtsaTotal.public_money3 +
      mindTotal.public_money3;
    this.tab.total_invoice5 =
      basicTotal.public_money4 +
      managementTotal.public_money4 +
      mtsaTotal.public_money4 +
      mindTotal.public_money4;
  }
}
